var MdaHandoutView, MdaHandoutsController, MdaHandoutsView, ModuleController, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

ModuleController = require('controllers/base/module_controller');

MdaHandoutsView = require('views/mda/mda_handouts_view');

MdaHandoutView = require('views/mda/mda_handout_view');

mediator = require('mediator');

module.exports = MdaHandoutsController = (function(_super) {
  __extends(MdaHandoutsController, _super);

  function MdaHandoutsController() {
    return MdaHandoutsController.__super__.constructor.apply(this, arguments);
  }

  MdaHandoutsController.prototype.index = function() {
    return this.view = new MdaHandoutsView;
  };

  MdaHandoutsController.prototype.handout = function(params) {
    return this.view = new MdaHandoutView({
      handoutId: params.id
    });
  };

  return MdaHandoutsController;

})(ModuleController);
